import Gt from "./filter-set.js";
export default class ts {
  constructor(t, s) {
    (this.productId = t), (this.Hl = s);
  }
  Gl(t) {
    if (null == this.productId || null == this.Hl) return !1;
    const s = t[0],
      i = t[1];
    return s === this.productId && this.Hl.Gl(i);
  }
  static fromJson(t) {
    return new ts(
      t ? t.product_id : null,
      t ? Gt.fromJson(t.property_filters) : null
    );
  }
  ss() {
    return { id: this.productId, pf: this.Hl.ss() };
  }
}
